import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getEmailsLog(params: any): AxiosPromise {
    return EndPointService.get('/email_logs', { params });
}
function resendEmailLog(id: string | number): AxiosPromise {
    return EndPointService.put('/email_logs/resend', {}, { params: { id } });
}
function getEmailLog(id: number | string): AxiosPromise {
    return EndPointService.get(`/api/email_logs/${id}`);
}
export default {
    getEmailsLog,
    resendEmailLog,
    getEmailLog,
};
